<div
    class="
    z-200
    bg-gray-200
    rounded-sm
    p-14
    relative
    transition-all
    ease-in-out
    transform
    hover:-translate-y-1 hover:scale-105 hover:shadow-2xl
    "
>
    <span
        class="
            bg-sky-700
            border
            border-sky-600
            rounded-full
            text-white
            inline-block
            text-2xl
            h-16
            w-16
            leading-10
            mb-6
            absolute
            text-center
            -top-8
        "
    >
        <slot name="icon"></slot>
    </span>
    <slot></slot>
</div>

  